<div
  class="orgApp-d-flex orgApp-flex-dir-col orgApp-gap-16 orgApp-upload-photo-main-div"
>
  <div class="orgApp-d-flex orgApp-gap-16 orgApp-justify-c-spc-btw">
    <h2 class="orgApp-upld-title orgApp-padding-left-16 orgApp-upload-m-0 orgApp-font-graphik orgApp-d-flex orgApp-align-i-center">
       {{ title | translate }}                                                                                                                                          
    </h2>
    <button
      class="orgApp-upload-cm-btn"
      type="button"
      mat-icon-button
      (click)="cancelForm()"
    >
    <svg width="24" height="24">
      <use xlink:href="#close-icon"></use>
    </svg>
    </button>
  </div>
  <div class="orgApp-d-flex orgApp-flex-dir-col orgApp-upld-wrpr">
    <mat-dialog-content class="orgApp-upload-photo-dialog-content">
      <!-- @if(editImgData?.staffImg!==null && editImgData?.staffApiImg){
      <div class="orgApp-d-flex orgApp-align-i-center orgApp-justify-c-center">
        <img class="orgApp-uploaded-img" mat-card-image [src]="editImgData?.staffImg" alt="Profile" />
      </div>
      } -->
      @if(imageChangedEvent===null || !imagePrepared){
      <app-file-upload
        height="201"
        width="268" class="orgApp-align-i-center orgApp-d-flex orgApp-flex-dir-col orgApp-justify-c-center"
        fileAreaHeight="128"
        fileAreaWidth="128"
        [showFileDetails]="showFileDetails" [imageId] = "editImgData?.imageUrl"
        (fileData)="fileChangeEvent($event)"
      ></app-file-upload>
      } @else{ @if(imagePrepared){
        <div class="orgApp-cropper-preview-container  orgApp-d-flex orgApp-align-i-center orgApp-justify-c-center">
          <image-cropper
              class="orgApp-upload-photo-cropper"
              [imageChangedEvent]="imageChangedEvent"
              [maintainAspectRatio]="!editImgData?.orgLogoImg"  
              [aspectRatio]="!editImgData?.orgLogoImg ? 4 / 4 : undefined"
              [transform]="transform"
              [cropperMinWidth]="200"
              [cropperMinHeight]="200"
              (imageCropped)="imageCropped($event)"
            ></image-cropper>
        </div>
      <mat-slider
        class="zoom-slider orgApp-upload-zoom"
        [min]="min"
        [max]="max"
        step="0.1"
        (input)="onSliderChange($event)"
      >
        <input matSliderThumb  [formControl]="value" #slider />
      </mat-slider>
      } }
    </mat-dialog-content>
    <mat-dialog-actions class="orgApp-d-flex orgApp-gap-16 orgApp-justify-c-spc-btw orgApp-upload-photo-action">
      <button
      mat-stroked-button
      class="orgApp-stroked-btn-danger orgApp-upld-button orgApp-upld-d-button"
      (click)="deleteImage()"
      [disabled]="!enableImgDelete"
    >
    <svg width="20" height="20">
      <use [attr.xlink:href]="enableImgDelete ? '#delete-outlined-blue' : '#delete-outlined-disabled'"></use>
    </svg>
    </button>
     <div class="orgApp-d-flex orgApp-gap-8 orgApp-upld-ac-div">
      <button
        mat-stroked-button
        class="orgApp-stroked-btn-primary orgApp-upld-button orgApp-modal-button"
        (click)="cancelForm()"
      >
        Cancel
      </button>
      <button
        mat-raised-button
        class="orgApp-raised-btn-primary orgApp-upld-button orgApp-modal-button"
        (click)="uploadPhoto()"
        [disabled]="!imagePrepared"
        [ngClass]="{
          disable: !imagePrepared
        }"
      >
        Save
      </button>
    </div>
    </mat-dialog-actions>
  </div>
</div>
